module.exports = __webpack_public_path__ + "img/symbol_1.d2fe8cd2.png";